import { IconButton } from '@flex-design-system/fx';
import { styled } from '@flex-design-system/stitches-react';

export const Container = styled(IconButton, {
  flexShrink: 0,
});
